
































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { BForm, BFormGroup, BFormSelect, BFormInput } from 'bootstrap-vue';
import MyContactInformationService from '@/profile/my-contact-information/services/my-contact-information.service';
import Rep from '@/_shared/entities/rep/rep.entity';
import RepContact from '@/_shared/entities/rep/rep-contact.entity';
import LogService from '@/_shared/services/log/log.service';
import store from '@/_shared/store';
import ContactForm from '@/profile/interfaces/contact-form.entity';
import AutoshipUpdateModal from '@/profile/components/autoships-update.modal.vue';
import UpdateAutoShipDataDTO from '@/profile/interfaces/autoship-data-update.dto';

@Component({
  components: {
    BForm,
    BFormGroup,
    BFormSelect,
    BFormInput,
    AutoshipUpdateModal,
  },
})
export default class MyContactInformationView extends Vue {
  private repData: RepContact | null = null;
  private currentData: RepContact | null = null;

  private hasFinishedLoading = false;
  private billingZipCode: string | null = null;
  private billingStreet1: string | null = null;
  private billingStreet2: string | null = null;
  private billingCity: string | null = null;
  private billingCounty: string | null = null;
  private billingState: string | null = null;
  private billingCountry = { name: '' };

  private billingZipCodeState: boolean | null = null;

  private shippingZipCode: string | null = null;
  private shippingStreet1: string | null = null;
  private shippingStreet2: string | null = null;
  private shippingCity: string | null = null;
  private shippingCounty: string | null = null;
  private shippingState: string | null = null;
  private shippingCountry = { name: '' };

  private shippingZipCodeState: boolean | null = null;

  private phoneHome = ''
  private phoneWork = ''
  private phoneMobile = ''
  private phoneFax = ''

  private email = ''

  private autoShipAddresses: UpdateAutoShipDataDTO[] = []
  shippingStateOptions: string[] =[]
  shippingCityOptions: string[] = []
  shippingCountyOptions: string[] = []

  billingStateOptions: string[] = []
  billingCityOptions: string[] = []
  billingCountyOptions: string[] = []

  private sameAsComission = false;

  get rep(): Rep { return this.$store.state.RepStore.rep; }

  get showBillingStateSelect(): boolean {
    if (this.isBillingInUsa) return true;
    return this.billingStateOptions.length > 0;
  }

  get showShippingStateSelect(): boolean {
    if (this.isShippingInUsa) return true;
    return this.shippingStateOptions.length > 0;
  }

  get disableSaveButton(): boolean {
    const hasInvalidBillingZipCode = (this.isBillingInUsa && this.billingZipCodeState === false);
    const hasInvalidShippingZipCode = (this.isShippingInUsa && this.shippingZipCodeState === false);
    return hasInvalidBillingZipCode || hasInvalidShippingZipCode;
  }

  get isShippingInUsa(): boolean {
    return this.shippingCountry.name === 'USA';
  }

  get isBillingInUsa(): boolean {
    return this.billingCountry.name === 'USA';
  }

  get zipCodePlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.ZIP_CODE').toString();
  }

  get shippingZipCodeErrorMessage(): string {
    if (this.shippingZipCode !== null && this.shippingZipCode.length > 0) {
      return this.$t('PROFILE.CONTACT_INFORMATION.INVALID_ZIP_CODE').toString();
    }

    return this.$t('GENERAL_ERROR.FIELD_REQUIRED').toString();
  }

  get billingZipCodeErrorMessage(): string {
    if (this.billingZipCode !== null && this.billingZipCode.length > 0) {
      return this.$t('PROFILE.CONTACT_INFORMATION.INVALID_ZIP_CODE').toString();
    }

    return this.$t('GENERAL_ERROR.FIELD_REQUIRED').toString();
  }

  get streetPlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.STREET').toString();
  }

  get countyPlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.COUNTY').toString();
  }

  get cityPlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.CITY').toString();
  }

  get selectCityPlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.SELECT_CITY').toString();
  }

  get statePlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.STATE').toString();
  }

  get selectStatePlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.SELECT_STATE').toString();
  }

  get phonePlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.PHONE').toString();
  }

  get emailPlaceholder(): string {
    return this.$t('PROFILE.CONTACT_INFORMATION.PLACEHOLDER.EMAIL').toString();
  }

  get zipLabel(): string {
    return `${this.$t('PROFILE.CONTACT_INFO.ADDRESEES_ZIP').toString()}*`;
  }

  get street2Label(): string {
    return this.$t('PROFILE.CONTACT_INFO.ADDRESEES_STREET_2').toString();
  }

  get streetLabel(): string {
    return `${this.$t('PROFILE.CONTACT_INFO.ADDRESEES_STREET').toString()}*`;
  }

  get cityLabel(): string {
    return `${this.$t('PROFILE.CONTACT_INFO.ADDRESEES_CITY').toString()}*`;
  }

  get countyLabel(): string {
    return `${this.$t('PROFILE.CONTACT_INFO.ADDRESEES_COUNTY').toString()}*`;
  }

  get countryLabel(): string {
    return this.$t('PROFILE.CONTACT_INFO.ADDRESEES_COUNTRY').toString();
  }

  get stateLabel(): string {
    return `${this.$t('PROFILE.CONTACT_INFO.ADDRESEES_STATE').toString()}*`;
  }

  get homePhoneLabel(): string {
    return `${this.$t('PROFILE.CONTACT_INFO.PHONE_HOME').toString()}*`;
  }

  get workPhoneLabel(): string {
    return this.$t('PROFILE.CONTACT_INFO.PHONE_WORK').toString();
  }

  get mobilePhoneLabel(): string {
    return this.$t('PROFILE.CONTACT_INFO.PHONE_CELL').toString();
  }

  get faxPhoneLabel(): string {
    return this.$t('PROFILE.CONTACT_INFO.PHONE_FAX').toString();
  }

  get emailLabel(): string {
    return `${this.$t('PROFILE.CONTACT_INFO.EMAIL_LABEL')
      .toString()}*`;
  }

  get comissionCountryIsSameAsShipping() {
    return this.shippingCountry.name === this.billingCountry.name;
  }

  get shippingStreetState() {
    return this.shippingStreet1 !== '' ? null : false;
  }

  get shippingCityState() {
    return this.shippingCity !== '' ? null : false;
  }

  get shippingCountyState() {
    return this.shippingCounty !== '' ? null : false;
  }

  get shippingStateState() {
    return this.shippingState !== '' ? null : false;
  }

  get billingStreetState() {
    return this.billingStreet1 !== '' ? null : false;
  }

  get billingCityState() {
    return this.billingCity !== '' ? null : false;
  }

  get billingStateState() {
    return this.billingState !== '' ? null : false;
  }

  get homePhoneState() {
    return this.phoneHome.trim() !== '' ? null : false;
  }

  get emailState() {
    return MyContactInformationService.isValidEmail(this.email) ? null : false;
  }

  created() {
    this.retrieveData();
  }

  private async retrieveData() {
    await this.$store.dispatch('showLoading');

    const data = await MyContactInformationService.getRepInfo(this.rep.did);
    this.currentData = { ...data };
    this.repData = { ...data };
    this.mountForm(data);

    try {
      await this.loadShippingData();
      await this.loadBillingData();
    } finally {
      this.hasFinishedLoading = true;
      this.$emit('done-loading');
      await this.$store.dispatch('hideLoading');
    }
  }

  private async loadShippingData(): Promise<void> {
    if (this.isShippingInUsa) {
      await this.loadShippingZipCode();
    } else {
      await this.loadShippingStates();
    }
  }

  private changeShippingZipCode(): void {
    if (!this.isShippingInUsa) {
      return;
    }

    this.$store.dispatch('showLoading');
    this.resetShippingAddress();
    this.loadShippingZipCode();
    this.$store.dispatch('hideLoading');
  }

  private async loadShippingZipCode(): Promise<void> {
    if (!this.shippingZipCode) return;
    const shippingCountryCode = await store.dispatch('getCountryCodeByCountryName', this.rep.shipping.country);

    const shippingOptions = await MyContactInformationService.getZipCodeInfo(
      shippingCountryCode,
      this.shippingZipCode ?? '',
    );

    this.shippingZipCodeState = null;
    if (shippingOptions.data.postal.count === 0) {
      this.shippingZipCodeState = false;
    }

    const shippingRegions = shippingOptions.data.postal.regions || [];
    this.shippingCityOptions = MyContactInformationService.extractCities(shippingRegions);
    this.shippingCountyOptions = MyContactInformationService.extractCounties(shippingRegions);
    this.shippingStateOptions = MyContactInformationService.extractStates(shippingRegions);
  }

  private resetShippingAddress(): void {
    this.shippingCity = null;
    this.shippingCounty = null;
    this.shippingState = null;

    this.shippingStateOptions = [];
    this.shippingCityOptions = [];
    this.shippingCountyOptions = [];
  }

  private async loadShippingStates(): Promise<void> {
    this.shippingStateOptions = [];
    const countryCode = await store.dispatch('getCountryCodeByCountryName', this.rep.shipping.country);
    this.shippingStateOptions = await MyContactInformationService.getStateInfos(countryCode);
  }

  private async loadBillingData(): Promise<void> {
    if (this.isBillingInUsa) {
      await this.loadBillingZipCode();
    } else {
      await this.loadBillingStates();
    }
  }

  private async loadBillingStates(): Promise<void> {
    this.billingStateOptions = [];
    const countryCode = await store.dispatch('getCountryCodeByCountryName', this.rep.billing.country);
    this.billingStateOptions = await MyContactInformationService.getStateInfos(countryCode);
  }

  private changeBillingZipCode(): void {
    if (!this.isBillingInUsa) {
      return;
    }

    this.$store.dispatch('showLoading');
    this.resetBillingAddress();
    this.loadBillingZipCode();
    this.$store.dispatch('hideLoading');
  }

  private async loadBillingZipCode(): Promise<void> {
    if (!this.billingZipCode) return;
    const billingCountryCode = await store.dispatch(
      'getCountryCodeByCountryName',
      this.rep.billing.country,
    );

    const billingOptions = await MyContactInformationService.getZipCodeInfo(
      billingCountryCode,
      this.billingZipCode ?? '',
    );

    this.billingZipCodeState = null;
    if (billingOptions.data.postal.count === 0) {
      this.billingZipCodeState = false;
    }

    const billingRegions = billingOptions.data.postal.regions || [];
    this.billingCityOptions = MyContactInformationService.extractCities(billingRegions);
    this.billingCountyOptions = MyContactInformationService.extractCounties(billingRegions);
    this.billingStateOptions = MyContactInformationService.extractStates(billingRegions);
  }

  private resetBillingAddress(): void {
    this.billingCity = null;
    this.billingCounty = null;
    this.billingState = null;

    this.billingStateOptions = [];
    this.billingCityOptions = [];
    this.billingCountyOptions = [];
  }

  private async onSubmit() {
    this.$store.dispatch('showLoading');

    const toUpdate = new ContactForm({
      billing: {
        postal: this.billingZipCode,
        street: [this.billingStreet1, this.billingStreet2],
        city: this.billingCity,
        county: this.billingCounty,
        state: this.billingState,
        country: this.billingCountry,
      },
      shipping: {
        postal: this.shippingZipCode,
        street: [this.shippingStreet1, this.shippingStreet2],
        city: this.shippingCity,
        county: this.shippingCounty,
        state: this.shippingState,
        country: this.shippingCountry,
      },
      phone: [this.phoneHome, this.phoneWork, this.phoneMobile, this.phoneFax],
      email: this.email,
    });

    if (!this.isValid(toUpdate)) return;
    [this.phoneHome, this.phoneWork, this.phoneMobile, this.phoneFax] = [this.phoneHome, this.phoneWork, this.phoneMobile, this.phoneFax].map((phone) => (phone === '' ? ' ' : phone.replace(/\s/g, '')));
    toUpdate.phone = [this.phoneHome, this.phoneWork, this.phoneMobile, this.phoneFax];

    if (this.sameAsComission) {
      toUpdate.shipping = toUpdate.billing;
      this.copyCommissionOverShippingAddress();
    }
    const updatedContactInfo = Object.assign(this.repData, toUpdate);
    try {
      await MyContactInformationService.updateContactInfo(this.rep.did, updatedContactInfo);
      const hasAutoships = await this.checkForAutoships();
      this.currentData = Object.assign(this.currentData, this.repData);
      this.mountForm(this.currentData);
      if (!hasAutoships) {
        this.showSuccessMessage();
      }
    } catch (e) {
      this.showErrorMessage();
    }

    await this.$store.dispatch('hideLoading');
  }

  private showSuccessMessage(): void {
    LogService.toastrSuccess(
      this.$t('PROFILE.TOAST_SUCCESS_MESSAGE').toString(),
      this.$t('PROFILE.TOAST_SUCCESS_HEADER').toString(),
    );
  }

  private showErrorMessage(): void {
    LogService.toastrError(
      this.$t('PROFILE.TOAST_ERROR_MESSAGE').toString(),
      this.$t('PROFILE.TOAST_ERROR_HEADER').toString(),
    );
  }

  async checkForAutoships(): Promise<boolean> {
    const autoships = await MyContactInformationService.getAutoshipAddresses();
    const hasAutoshipsToUpdate = !(autoships == null || autoships.profiles == null
     || autoships.profiles.length === 0) && this.shippingAddressHasChanged();
    if (hasAutoshipsToUpdate) {
      this.autoShipAddresses = autoships.profiles;
      (this.$refs.autoshipsModal as AutoshipUpdateModal).show(this.updateAutoShipData);
    }

    return hasAutoshipsToUpdate;
  }

  shippingAddressHasChanged() {
    return this.currentData?.shipping.city !== this.shippingCity
                        || this.currentData.shipping.county !== this.shippingCounty
                        || this.currentData.shipping.street[0] !== this.shippingStreet1
                        || this.currentData.shipping.street[1] !== this.shippingStreet2
                        || this.currentData.shipping.postal !== this.shippingZipCode
                        || this.currentData.shipping.state !== this.shippingState;
  }

  get updateAutoShipData(): UpdateAutoShipDataDTO {
    return {
      address: {
        postal: this.shippingZipCode || '',
        street1: this.shippingStreet1 || '',
        street2: this.shippingStreet2 || '',
        city: this.shippingCity || '',
        county: this.shippingCounty || '',
        state: this.shippingState || '',
        country: this.shippingCountry.name,
      },
      name: `${this.rep.firstName} ${this.rep.lastName}`,
      phone: {
        cell: this.phoneMobile,
        fax: this.phoneFax,
        home: this.phoneHome,
        work: this.phoneWork,
      },
    };
  }

  isValid(updatedData: ContactForm) {
    if (!updatedData.hasAtLeastOnePhone()) {
      LogService.toastrError(this.$t('PROFILE.CONTACT_INFO.PHONE_LEGEND').toString());
      return false;
    }

    if (!updatedData.hasRequiredData()) {
      LogService.toastrError(this.$t('GENERAL_ERROR.FIELD_REQUIRED').toString());
      return false;
    }
    return true;
  }

  copyCommissionOverShippingAddress() {
    this.shippingZipCode = this.billingZipCode;
    [this.shippingStreet1, this.shippingStreet2] = [this.billingStreet1, this.billingStreet2];
    this.shippingCity = this.billingCity;
    this.shippingCounty = this.billingCounty;
    this.shippingState = this.billingState;
  }

  mountForm(data: RepContact | null) {
    const [phoneHome, phoneWork, phoneMobile, phoneFax] = data?.phone || '';

    this.billingZipCode = data?.billing.postal || null;
    this.billingStreet1 = data?.billing.street[0] || null;
    this.billingStreet2 = data?.billing.street[1] || null;
    this.billingCity = data?.billing.city || null;
    this.billingCounty = data?.billing.county || null;
    this.billingState = data?.billing.state || null;
    this.billingCountry = { name: data?.billing.country.name || '' };

    this.shippingZipCode = data?.shipping.postal || null;
    this.shippingStreet1 = data?.shipping.street[0] || null;
    this.shippingStreet2 = data?.shipping.street[1] || null;
    this.shippingCity = data?.shipping.city || null;
    this.shippingCounty = data?.shipping.county || null;
    this.shippingState = data?.shipping.state || null;
    this.shippingCountry = { name: data?.shipping.country.name || '' };

    this.phoneHome = phoneHome;
    this.phoneWork = phoneWork.trim();
    this.phoneMobile = phoneMobile.trim();
    this.phoneFax = phoneFax.trim();

    this.email = data?.email || '';
  }
}
